import React, { PropTypes } from 'react';
import StarRating from 'common/components/star_rating';
import sortBy from 'lodash/sortBy';
import reduce from 'lodash/reduce';
import { v4 } from 'node-uuid';

import Utils from 'focus_groups/utils';
import Gallery from 'common/components/gallery';
import Thumbnail from 'common/components/thumbnail';
import ResultTabs from 'focus_groups/containers/result_tabs';
import ResultVoteRow from 'focus_groups/components/result_vote_row';
import ResultCommentTile from 'focus_groups/components/result_comment_tile';


const ResultComments = ({ votes, revision, entry_number, showVotes, showComments }) => {
  const { averageScore, numVotes, thumbnailImage } = Utils({ votes, revision });

  const votesByDate = sortBy(votes, ({ created_by }) => (created_by));
  const comments = reduce(votes, (mem, vote) => (vote.comment ? [...mem, vote] : mem), []);

  return (<div className="row align-center">
            <div className="columns small-8 large-5">
              <div className="tile read-only">
                <Thumbnail className="thumbnail flex" image={thumbnailImage} />
              </div>
              <h5 className="entry-number">entry #{entry_number}</h5>
            </div>
            <div className="columns small-16 large-11">
              <div className="row focus-group-stats">
                <div className="small-5">
                  <span className="stat-label">Group Score</span>
                  <p className="stat-value">{averageScore}</p>
                </div>
                <div className="small-5">
                  <span className="stat-label">Votes</span>
                  <p className="stat-value">{numVotes}</p>
                </div>
                <div className="small-6">
                  <span className="stat-label">Your Score</span>
                  <div className="stat-value">
                    <StarRating readonly={true} initialRate={revision.score}/>
                  </div>
                </div>
              </div>
              <ResultTabs />
              <div className="results-comments">
                {showComments && comments.map(comment => <ResultCommentTile
                  key={v4()}
                  {...comment}
                />)}

                {showVotes && <table className="table table-default">
                  <thead>
                    <tr>
                      <td>Email</td>
                      <td className="hide-for-small-only">Name</td>
                      <td>Vote</td>
                      <td className="hide-for-small-only">Vote Date</td>
                    </tr>
                  </thead>
                  <tbody>
                    {votesByDate.map(vote => <ResultVoteRow key={v4()} {...vote} />)}
                  </tbody>
                </table>}
              </div>
            </div>
          </div>);
};

ResultComments.propTypes = {
  votes: PropTypes.object.isRequired,
  revision: PropTypes.object.isRequired,
  showVotes: PropTypes.bool,
  showComments: PropTypes.bool,
};

export default ResultComments;



// WEBPACK FOOTER //
// ./focus_groups/components/result_comments.jsx